module.exports = {"title":"連接·生活","open":"打開","openButton":"打開MyLink查看更多","download":"下載 MyLink APP","ios":"請點擊右上角的“…”按鈕，選擇“在Safari中開啟”","android":"請點擊右上角的“…”按鈕，選擇“在瀏覽器中開啟”","downloadApp":"立即下載MyLink瀏覽更多資訊","register":"安裝完成，請註冊或登入您的帳號"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/share/zh-hk.json
// module id = UeCv
// module chunks = 1